import React, {useState} from 'react';
import { SingleBookIcon, DoubleBookIcon, AngleDownIcon } from '@/utils/svgIcons';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

export default function BookViewMenu({
  step,
  bookViewMenu,
  bookView,
  setBookview,
  setBookViewMenu
}: any) {
  const {t} = useTranslation('personalizeModal');
  const {locale} = useRouter();
  if (step !== 'review') return null;
  
  if(bookViewMenu === false && step !== 'info')
    return(
        <div className='hidden absolute top-12 left-1/2 z-[140] -translate-x-1/2 bg-white p-1 lg:flex items-center justify-center rounded-full shadow-2xl' id='book-view-menu' onClick={()=>{setBookViewMenu(true)}}>
          <AngleDownIcon/>
        </div>
    )

    
  return (
    <div className={`hidden absolute top-20 left-1/2 z-[140] -translate-x-1/2 bg-white py-2 px-4 ${locale === 'ar' ? 'lg:flex': 'lg:flex flex-row-reverse'} items-center justify-center gap-4 rounded-2xl`} id='book-view-menu'>
      <div 
        className={`flex flex-col gap-2 py-2 px-4 items-center justify-center ${bookView === 'single' ? 'bg-success text-primary rounded-md' : 'text-[#00214D66]'}`} 
        onClick={() => {
          setBookview('single');
          setBookViewMenu(false);
        }}
      >
        <div className="w-5 h-5">
          <SingleBookIcon/>
        </div>
        <p className='font-normal text-base mt-2'>{t('singleView')}</p>
      </div>
      <div 
        className={`flex flex-col gap-2 py-2 px-4 items-center justify-center ${bookView === 'double' ? 'bg-success text-primary rounded-md' : 'text-[#00214D66]'}`}  
        onClick={() => {
          setBookview('double');
          setBookViewMenu(false);
        }}
      >
        <div className="flex items-center justify-center gap-1">
          <DoubleBookIcon/>
        </div>
        <p className='font-normal text-base mt-2'>{t('doubleView')}</p>
      </div>
    </div>
  );
}